import type { StoresType } from 'api/Stores'
import React, { memo } from 'react'
import { useTranslation } from 'react-i18next'

import ToggleButton from '@mui/material/ToggleButton'
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup'

import useStyles from './useStyles'

interface Props {
  showStores: boolean
  showWebsites: boolean
  contentType: StoresType
  onChange: (contentType: StoresType) => void
}

function DetailsToggleButtonGroup({ contentType, showStores, showWebsites, onChange }: Props) {
  const { t: translate } = useTranslation()
  const classes = useStyles()
  const buttonClasses = {
    root: classes.rootToggleButton,
    selected: classes.selectedToggleButton,
  }
  const handleAlignment = (_event: React.SyntheticEvent, newContentType: StoresType | null) => {
    if (newContentType && newContentType !== contentType) {
      onChange(newContentType)
    }
  }

  return (
    <ToggleButtonGroup className={classes.toggleButtonGroup} size="small" value={contentType} exclusive onChange={handleAlignment}>
      {showStores && (
        <ToggleButton classes={buttonClasses} value="stores">
          {translate('revenue.stores')}
        </ToggleButton>
      )}
      {showWebsites && (
        <ToggleButton classes={buttonClasses} value="websites">
          {translate('revenue.websites')}
        </ToggleButton>
      )}
      <ToggleButton classes={buttonClasses} value="default">
        {translate('revenue.summary')}
      </ToggleButton>
    </ToggleButtonGroup>
  )
}

export default memo(DetailsToggleButtonGroup)
